<div class="modal-header bg-am-darkblue-x border-0">
  <h3 class="modal-title text-white fs-36px fw-medium-x">
    <i class="fas fa-credit-card me-3"></i>
    {{ 'payment_simulator.title' | translate }}
  </h3>
  <button type="button" class="am-modal-close" aria-label="Close" (click)="cancel()">
    <i class="fas fa-times"></i>
  </button>
</div>

<div class="modal-body bg-am-darkblue-x p-5">
  <!-- Información del monto -->
  <div class="alert alert-info bg-blue-cart border-0 text-white mb-4 p-4 rounded">
    <div class="d-flex align-items-center">
      <i class="fas fa-info-circle fs-32px me-3"></i>
      <div>
        <p class="mb-1 fs-18px opacity-75">{{ 'payment_simulator.amount_label' | translate }}</p>
        <p class="mb-0 fs-42px fw-medium-x">${{ amount | number:'1.2-2' }} MXN</p>
      </div>
    </div>
  </div>

  <!-- Selección de marca de tarjeta -->
  <div class="mb-5">
    <label class="form-label text-white fs-24px fw-medium mb-3">
      <i class="fas fa-credit-card me-2"></i>
      {{ 'payment_simulator.select_brand' | translate }}
    </label>
    <div class="row g-3">
      <div class="col-4" *ngFor="let brand of brands">
        <button 
          type="button"
          class="btn brand-card w-100 h-100 p-4"
          [class.selected]="selectedBrand === brand.value"
          (click)="selectBrand(brand.value)">
          <i class="fab fa-{{brand.icon}} fs-60px mb-3"></i>
          <div class="fs-20px fw-medium">{{ brand.label }}</div>
        </button>
      </div>
    </div>
  </div>

  <!-- Selección de escenario -->
  <div class="mb-4">
    <label class="form-label text-white fs-24px fw-medium mb-3">
      <i class="fas fa-flask me-2"></i>
      {{ 'payment_simulator.select_scenario' | translate }}
    </label>
    <div class="row g-3">
      <div class="col-6" *ngFor="let scenario of scenarios">
        <button 
          type="button"
          class="btn scenario-card w-100 text-start p-4"
          [class.selected]="selectedScenario === scenario.value"
          [class.scenario-success]="scenario.color === 'success'"
          [class.scenario-danger]="scenario.color === 'danger'"
          [class.scenario-warning]="scenario.color === 'warning'"
          (click)="selectScenario(scenario.value)">
          <div class="d-flex align-items-center">
            <i class="fas fa-{{scenario.icon}} fs-36px me-3"></i>
            <span class="fs-18px fw-medium">{{ scenario.label | translate }}</span>
          </div>
        </button>
      </div>
    </div>
  </div>

  <!-- Advertencia -->
  <div class="alert alert-warning bg-red border-0 text-white p-4 rounded">
    <div class="d-flex align-items-start">
      <i class="fas fa-exclamation-triangle fs-28px me-3 mt-1"></i>
      <div class="fs-16px">
        <strong class="d-block mb-1">{{ 'payment_simulator.warning_title' | translate }}</strong>
        {{ 'payment_simulator.warning_message' | translate }}
      </div>
    </div>
  </div>
</div>

<div class="modal-footer bg-am-darkblue-x border-0 p-4">
  <button 
    type="button" 
    class="btn btn-lg bg-transparent border-am text-white fs-24px px-5 py-3 rounded-pill me-3"
    (click)="cancel()">
    <i class="fas fa-times me-2"></i>
    {{ 'cancel' | translate }}
  </button>
  <button 
    type="button" 
    class="btn btn-lg bg-am-blue text-white fs-24px px-5 py-3 rounded-pill"
    (click)="confirm()">
    <i class="fas fa-play me-2"></i>
    {{ 'payment_simulator.simulate' | translate }}
  </button>
</div>


